var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlayPreviewWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.147 8.789c2.457 1.42 2.474 4.792.03 6.234L5.923 23.439C3.343 24.962 0 23.207 0 20.33V3.67C0 .808 3.312-.95 5.893.544l14.254 8.245z",
    fill: "#fff"
  })));
}

export default SvgPlayPreviewWhite;